import React from 'react';
import { connect } from 'react-redux';
import classNames from "classnames";

import imgPreview from './imgPreview.png';

import './index.css';
import Icon from "../../components/Icon";

class AlertInAppPreview extends React.Component {
    state = {
        lang: 'fr-FR',
    };

    toggleLang(lang) {
        this.setState({ lang });
    }

    render() {
        const { lang } = this.state;
        const { data } = this.props;
        return (
            <div id="alertInAppPreview" className="col-md-6">
                <div className="inline lang">
                    <button
                        className={classNames('btn btn-box-tool', { selected: lang === 'fr-FR'})}
                        onClick={() => this.toggleLang('fr-FR')}
                    >
                        <span className="flag-icon flag-icon-fr"/>
                    </button>
                    <button
                        className={classNames('btn btn-box-tool', { selected: lang === 'en-GB' })}
                        onClick={() => this.toggleLang('en-GB')}
                    >
                        <span className="flag-icon flag-icon-gb"/>
                    </button>
                    <button
                        className={classNames('btn btn-box-tool', { selected: lang === 'es-ES' })}
                        onClick={() => this.toggleLang('es-ES')}
                    >
                        <span className="flag-icon flag-icon-es"/>
                    </button>
                </div>
                <div className="previewContainer">
                    <img src={imgPreview} alt="" width="320"/>
                    <div className="containerModal">
                        <div className="modalHeader">
                            <p className="modalTitle">{data.localization && data.localization[lang] && data.localization[lang].title}</p>
                            <Icon className="closeButton" type="close"/>
                        </div>
                        <div className="modalContent">
                            {data.localization && data.localization[lang] && data.localization[lang].imageUrl && (
                                <img
                                    className="upload"
                                    src={data.localization[lang].imageUrl}
                                    alt={data.localization[lang].imageUrl}
                                />
                            )}
                            <span
                                className="text"
                                dangerouslySetInnerHTML={{ __html: data.localization && data.localization[lang] && data.localization[lang].description }}
                            />
                        </div>
                        {data.localization && data.localization[lang] && data.localization[lang].button && data.localization[lang].button.text && (
                            <div className="text-center">
                                <button className="button">{data.localization[lang].button.text}</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({ state }),
    dispatch => ({ dispatch }),
    null,
    { pure: false }
)(AlertInAppPreview);



// WEBPACK FOOTER //
// ./src/pages/AlertMPG/AlertMpgPreview.js